var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"element-studio-media-options mb-3"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Video Options")]),_c('v-autocomplete',{attrs:{"label":"Providers","value":_vm.internalValue.providers,"items":_vm.types,"multiple":true,"hint":"All providers are allowed by default."},on:{"input":_vm.updateProviders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }